import React, { type PropsWithChildren } from 'react'
import { DynamicModuleLoader, type IModuleTuple } from 'redux-dynamic-modules'

interface DynamicModuleLoaderComponentProps {
  modules: IModuleTuple
}

const DynamicModuleLoaderComponent = ({
  children,
  ...props
}: PropsWithChildren<DynamicModuleLoaderComponentProps>) => {
  return (
    <DynamicModuleLoader strictMode={false} {...props}>
      {children}
    </DynamicModuleLoader>
  )
}

export default DynamicModuleLoaderComponent
